<template>
  <div>
    <div class="pay-loading">
      <loading
        :box-size="14"
        :round-size="3"
        :color="'#3d81ff'"></loading>
    </div>
    <div class="txt">考试列表加载中... </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading'
import { post, get } from '@/utils/ajax'

export default {
  components: {
    Loading
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    theme () {
      return this.$store.state.theme
    }
  },
  data () {
    return {
      timer: null,
      num: 5
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async weishengAPI () {
      if (this.$store.state.hasToken) {
        await this.$auth('logout')
      }
      const params = {
        uniq_id: this.$route.query.uniq_id,
        client_id: 'WEB',
        pid: 'egLIJPgY'
      }
      localStorage.UniqId = this.$route.query.uniq_id
      try {
        const res = await post(`${window.CONFIG.api_backend}/tiger/v3/web/accounts/oauth/wotime`, params)
        if (res.auth && res.auth.token) {
          const userInfo = await this.$auth('get_profile')
          localStorage.currentAccount = this.$route.query.uniq_id.split(':')[0]
          this.$store.commit('SET_USER', userInfo)
          this.$store.commit('HAS_TOKEN', true)
          localStorage.examId = ''
          const url = this.$route.query.redirect || 'http://web3.wotime.com.cn/'
          // 广告限制
          const a = document.createElement('a')
          a.setAttribute('href', url)
          document.body.appendChild(a)
          a.click()
        }
      } catch (error) {
        console.log(error)
      }
    },
    async eduTeacherAPI () {
      localStorage.examId = ''
      if (!(this.$route.query.examId && this.$route.query.unitId && this.$route.query.lessonId && this.$route.query.type && this.$route.query.resourceId)) {
        this.$message('未指定排考，请由未来教室跳转进入考试')
        return
      }
      if (!this.user.id) {
        this.$message('未登录账号，请由未来教室跳转进入考试')
        return
      }
      const data = {
        userId: this.user.id,
        examId: this.$route.query.examId,
        unitId: this.$route.query.unitId,
        lessonId: this.$route.query.lessonId,
        resourceId: this.$route.query.resourceId,
        type: this.$route.query.type
      }
      try {
        const info = localStorage.eduTeacher ? JSON.parse(localStorage.eduTeacher) : {}
        info['exam' + this.$route.query.examId] = data
        localStorage.eduTeacher = JSON.stringify(info)
        const paramsStatus = await get(`/home/sites/exams/${this.$route.query.examId}/users`)
        if (!paramsStatus && this.theme.has_param) {
          await post(`/home/sites/params/auto/arrange`, { address: location.origin + '/' + location.href.split('/')[3], exam_id: this.$route.query.examId, user_id: this.user.id })
        }
        if (window.location.href.indexOf(CONFIG.noc2024) !== -1) {
          location.href = CONFIG.nocLogin
        } else {
          this.$router.push({ name: 'login' })
        }
      } catch (error) {
        if (!error.error_code) {
          this.$message('解析失败，请刷新')
          localStorage.removeItem('eduTeacher')
        }
        console.log(error)
      }
    },
    init () {
      // xxxxweishengxxxx
      if (this.$route.path.split('/')[1].indexOf(this.$store.state.weishengRoute) >= 0) {
        this.weishengAPI()
      } else if (this.$route.path.split('/')[1].indexOf(this.$store.state.eduteacherRoute) >= 0) {
        this.eduTeacherAPI()
      }
    }
  },
  destroyed () {}
}
</script>

<style lang="scss" scoped>
  .pay-loading {
    display: flex;
    justify-content: center;
    padding-top: 250px;
    margin-bottom: 70px;
  }
  .txt {
    overflow: hidden;
    color: #333;
    text-align: center;
    font-size: 24px;
    // padding-top: 300px;
  }
  .number {
    font-size: 30px;
  }
</style>
